// const siteheader = document.querySelector(".site-header");

// const scrollUp = "scroll-up";

// const scrollDown = "scroll-down";

// let lastScroll = 0;

 

// window.addEventListener("scroll", () => {
// 	const currentScroll = window.pageYOffset;
// 	if (currentScroll <= siteheader.offsetHeight) {
// 		siteheader.classList.remove(scrollUp);
// 		return;
// 	}
// 	if (currentScroll > lastScroll && !siteheader.classList.contains(scrollDown)) {
// 		// down
// 		siteheader.classList.remove(scrollUp);
// 		siteheader.classList.add(scrollDown);
// 	} else if ( currentScroll < lastScroll && siteheader.classList.contains(scrollDown)	) {
// 		// up
// 		siteheader.classList.remove(scrollDown);
// 		siteheader.classList.add(scrollUp);
// 	}
// 	lastScroll = currentScroll;
// });

/*const siteheader = document.querySelector(".site-header");
const siteheaderTop = siteheader.offsetTop;

window.addEventListener("scroll", () => {
	if (window.scrollY >= siteheaderTop + 64) {
		siteheader.classList.add('fixed-header');
	} else {
		siteheader.classList.remove('fixed-header');
	}
});*/

( function () {
	( function ( $ ) {
        jQuery(".menu-icon").click(function(){
            jQuery(".menu-icon").toggleClass("active");
            jQuery(".full-menu-detail").toggleClass("active");
            jQuery(".top-header-inner").toggleClass("active");
            jQuery(".socials").toggleClass("active");
            jQuery("body").toggleClass("overflow");
            jQuery('.top-header').toggleClass('active-two');
            
          });
          jQuery(".full-menu-box-top ul.full-menu li a").click(function(){
            jQuery(".menu-icon").removeClass("active");
            jQuery(".full-menu-detail").removeClass("active");
            jQuery(".top-header-inner").removeClass("active");
            jQuery(".socials").removeClass("active");
            jQuery("body").removeClass("overflow");
            jQuery('.top-header').removeClass('active-two');
           
         });

    } )( jQuery );    
} )();